import { useGraphqlMutation } from '@dustin-web/microsite-data/src/hooks'
import { NOTIFY_CLICK } from '@dustin-web/microsite-data/src/graphql/product/notify-click.graphql'
import {
  NotifyClickMutation,
  NotifyClickMutationVariables,
} from '@dustin-web/microsite-data/src/graphql/product/generated/graphql-types'
export type UseNotifyClick = typeof useNotifyClick

export default function useNotifyClick() {
  const [notifyClick] = useGraphqlMutation<NotifyClickMutation, NotifyClickMutationVariables>(
    NOTIFY_CLICK
  )
  return (params: { variables: NotifyClickMutationVariables }) => notifyClick(params)
}
